module.exports = __webpack_public_path__ + "static/media/purty_wood_@2X.8ed5781b.png";